export default __webpack_public_path__ + "static/media/Asset-2.fd939b5c.png";